<!-- 设置逻辑弹层组件 - PC 端 -->
<template>
  <div class="set-logic-dialog-container">
    <el-dialog
      :visible="visible"
      @update:visible="$emit('update:visible', $event)"
      @close="handleClose"
      title="设置逻辑"
      width="900px"
      :close-on-click-modal="false"
      custom-class="set-logic-dialog"
    >
      <div class="set-logic-content">
        <!-- 设置逻辑 -->
        <!-- <div class="section-title">设置逻辑</div> -->

        <!-- 逻辑类型选择 -->
        <div class="logic-type-box">
          <div
            class="logic-type-item"
            :class="{ 'logic-type-active': logicType === 'SHOW' }"
            @click="switchLogicType('SHOW')"
          >
            <div class="logic-check-box">
              <img
                v-if="logicType === 'SHOW'"
                class="check-icon"
                src="https://ossfastmake.mustke.com/12jielong/bdJL/has-chose.svg"
              />
              <div v-else class="check-empty"></div>
            </div>
            <div class="logic-type-info">
              <div
                class="logic-type-name"
                :class="{ 'active-text': logicType === 'SHOW' }"
              >
                逻辑显示设置项
              </div>
              <div class="logic-type-desc">
                勾选后系统将展示该设置对应的题目
              </div>
            </div>
          </div>

          <div
            class="logic-type-item"
            :class="{ 'logic-type-active': logicType === 'JUMP' }"
            @click="switchLogicType('JUMP')"
          >
            <div class="logic-check-box">
              <img
                v-if="logicType === 'JUMP'"
                class="check-icon"
                src="https://ossfastmake.mustke.com/12jielong/bdJL/has-chose.svg"
              />
              <div v-else class="check-empty"></div>
            </div>
            <div class="logic-type-info">
              <div
                class="logic-type-name"
                :class="{ 'active-text': logicType === 'JUMP' }"
              >
                题目跳转设置
              </div>
              <div class="logic-type-desc">
                当选中指定选项时，系统将自动跳转至预设的对应题目
              </div>
            </div>
          </div>
        </div>

        <!-- 设置选项逻辑 -->
        <div class="section-title">设置选项逻辑</div>
        <div class="option-list">
          <div
            class="option-item"
            v-for="(item, index) in currentFieldContent"
            :key="index"
            @click="openSetPopup(index)"
          >
            <div class="option-left">
              <div class="option-number">{{ index + 1 }}</div>
              <div class="option-info">
                <div class="option-name">
                  {{ item.value || "选项" + (index + 1) }}
                </div>
                <div class="option-rule-text" v-if="getOptionRuleText(item)">
                  {{ getOptionRuleText(item) }}
                </div>
              </div>
            </div>
            <div class="option-right">
              <span
                class="option-status"
                :class="{ 'has-set': hasOptionRule(item) }"
              >
                {{ hasOptionRule(item) ? "修改" : "未设置" }}
              </span>
              <i
                class="el-icon-arrow-right"
                style="color: #999; font-size: 14px"
              ></i>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="saveLogic">保存</el-button>
        </div>
      </template>
    </el-dialog>
    <!-- 设置逻辑显示项弹窗（SHOW 模式） -->
    <el-dialog
      :visible.sync="showPopupVisible"
      title="设置逻辑显示项（可多选）"
      width="600px"
      :close-on-click-modal="false"
      custom-class="inner-popup-dialog"
    >
      <div class="popup-scroll">
        <div
          v-for="(field, fIdx) in availableFields"
          :key="fIdx"
          class="popup-item-wrap"
        >
          <div class="popup-item" @click="toggleShowField(field)">
            <div class="popup-check-box">
              <img
                v-if="isShowFieldSelected(field)"
                class="check-icon"
                src="https://ossfastmake.mustke.com/12jielong/bdJL/has-chose.svg"
              />
              <div v-else class="check-empty"></div>
            </div>
            <div class="popup-item-text">
              {{ field.displayIndex }}、{{ field.fieldName }}
            </div>

            <!-- 子选项设置入口 -->
            <div
              v-if="isChoiceField(field)"
              class="sub-setting-entry"
              @click.stop="openSubPopup(field)"
            >
              <span
                class="sub-setting-text"
                :class="{ 'selected-text': isShowFieldSelected(field) }"
              >
                {{ getSubSettingText(field) }}
              </span>
              <i
                class="el-icon-arrow-right"
                style="color: #999; font-size: 12px"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div class="norecord-box" v-if="availableFields.length == 0">
        <img
          src="https://ossfastmake.mustke.com/12jielong/lsyJL/dxnorecord.png"
          class="norecord-img"
        />
        <div class="norecord-text">
          当前为最后一题，没有可设置显示逻辑的题目
        </div>
      </div>
      <template #footer>
        <el-button type="primary" @click="confirmShowSetting">保存</el-button>
      </template>
    </el-dialog>

    <!-- 子选项选择项弹窗 -->
    <el-dialog
      :visible.sync="subPopupVisible"
      title="请选择显示的子选项"
      width="600px"
      :close-on-click-modal="false"
      custom-class="inner-popup-dialog"
    >
      <div v-if="currentSubField" class="sub-field-info">
        {{ currentSubField.displayIndex }}、{{ currentSubField.fieldName }}
      </div>
      <div class="popup-scroll">
        <div
          class="popup-item"
          v-for="(opt, oIdx) in currentSubField ? currentSubField.content : []"
          :key="oIdx"
          @click="toggleSubOption(oIdx)"
        >
          <div class="popup-check-box">
            <img
              v-if="tempSubIndices.includes(oIdx)"
              class="check-icon"
              src="https://ossfastmake.mustke.com/12jielong/bdJL/has-chose.svg"
            />
            <div v-else class="check-empty"></div>
          </div>
          <div class="popup-item-text">
            <div class="option-badge">{{ oIdx + 1 }}</div>
            <span>{{ opt.value || "选项" + (oIdx + 1) }}</span>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="popup-footer-btns">
          <div class="sub-all-check" @click="toggleAllSubOptions">
            <div class="popup-check-box">
              <img
                v-if="isAllSubSelected"
                class="check-icon"
                src="https://ossfastmake.mustke.com/12jielong/bdJL/has-chose.svg"
              />
              <div v-else class="check-empty"></div>
            </div>
            <span>全选</span>
          </div>
          <el-button type="primary" @click="confirmSubSetting"
            >保存并返回</el-button
          >
        </div>
      </template>
    </el-dialog>

    <!-- 题目跳转设置弹窗（JUMP 模式） -->
    <el-dialog
      :visible.sync="jumpPopupVisible"
      title="题目跳转设置"
      width="600px"
      :close-on-click-modal="false"
      custom-class="inner-popup-dialog"
    >
      <div class="popup-scroll">
        <!-- 跳转至结束选项 -->
        <div class="popup-item" @click="selectJumpTarget('end')">
          <div class="popup-check-box">
            <img
              v-if="selectedJumpTarget === 'end'"
              class="check-icon"
              src="https://ossfastmake.mustke.com/12jielong/bdJL/has-chose.svg"
            />
            <div v-else class="check-empty"></div>
          </div>
          <div class="popup-item-text">跳转至结束</div>
        </div>
        <!-- 其他题目 -->
        <div
          class="popup-item"
          v-for="(field, fIdx) in availableFields"
          :key="fIdx"
          @click="selectJumpTarget(field)"
        >
          <div class="popup-check-box">
            <img
              v-if="isJumpFieldSelected(field)"
              class="check-icon"
              src="https://ossfastmake.mustke.com/12jielong/bdJL/has-chose.svg"
            />
            <div v-else class="check-empty"></div>
          </div>
          <div class="popup-item-text">
            {{ field.displayIndex }}、{{ field.fieldName }}
          </div>
        </div>
      </div>
      <template #footer>
        <div class="popup-footer-btns">
          <el-button @click="closeJumpPopup">取消</el-button>
          <el-button type="primary" @click="confirmJumpSetting">确定</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 切换逻辑类型确认弹窗 -->
    <el-dialog
      :visible.sync="switchConfirmPopupVisible"
      title="提示"
      width="400px"
      :close-on-click-modal="false"
      custom-class="confirm-dialog"
    >
      <div class="confirm-body">
        当前题目已设置逻辑。切换逻辑方式后，现有设置将被清空
      </div>
      <template #footer>
        <div class="confirm-footer">
          <el-button @click="cancelSwitch">取消</el-button>
          <el-button type="primary" @click="confirmSwitch">确认</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "SetLogicDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    fieldData: {
      type: Object,
      required: true,
    },
    fieldIndex: {
      type: Number,
      required: true,
    },
    listIndex: {
      type: Number,
      default: 0,
    },
    allSignFields: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:visible", "save"],
  data() {
    return {
      logicType: "SHOW", // 当前逻辑类型：SHOW 或 JUMP
      currentFieldData: {}, // 当前单选项的完整数据
      currentFieldIndex: 0, // 当前单选项在 signField 中的索引
      currentFieldContent: [], // 当前单选的选项列表（content 数组）
      editingOptionIndex: -1, // 当前正在编辑的选项索引

      // SHOW 模式：临时选中的显示项 ID 列表
      tempShowFieldIds: [],
      tempShowSubOptions: {}, // { fieldId: { all: true, selectedIndices: [] } }

      // 子选项设置相关
      currentSubField: null,
      tempSubIndices: [],

      // JUMP 模式：临时选中的跳转目标
      selectedJumpTarget: null, // 'end' 或 field 对象

      // 切换确认
      pendingSwitchType: "",

      // 内层弹窗控制
      showPopupVisible: false,
      subPopupVisible: false,
      jumpPopupVisible: false,
      switchConfirmPopupVisible: false,
    };
  },
  computed: {
    // 可选的填写项列表（当前单选之后的所有题目）
    availableFields() {
      if (!this.allSignFields || !this.allSignFields.length) return [];
      const fields = [];
      for (
        let i = this.currentFieldIndex + 1;
        i < this.allSignFields.length;
        i++
      ) {
        const field = this.allSignFields[i];
        if (field.type == 33) continue; // 跳题目标通常是具体题目，跳过标题类
        fields.push({
          ...field,
          originalIndex: i,
          displayIndex: this.getFieldDisplayIndex(i), // 显示用的序号（跳过标题）
          fieldId: String(this.getFieldDisplayIndex(i)), // 使用显示的序号作为标识
        });
      }
      return fields;
    },
    isAllSubSelected() {
      if (!this.currentSubField || !this.currentSubField.content) return false;
      return this.tempSubIndices.length === this.currentSubField.content.length;
    },
  },
  watch: {
    visible(val) {
      console.log("SetLogicDialog visible changed:", val);
      if (val) {
        this.initData();
      }
    },
  },
  mounted() {
    console.log("SetLogicDialog mounted, visible:", this.visible);
    this.initData();
  },
  methods: {
    // 初始化数据
    initData() {
      this.currentFieldData = JSON.parse(JSON.stringify(this.fieldData || {}));
      this.currentFieldIndex = this.fieldIndex || 0;
      this.currentFieldContent = JSON.parse(
        JSON.stringify(this.fieldData.content || []),
      );
      this.detectExistingLogicType();
    },

    // 判断当前已有的逻辑类型
    detectExistingLogicType() {
      for (let item of this.currentFieldContent) {
        if (item.logicRules && item.logicRules.length > 0) {
          this.logicType = item.logicRules[0].ruleType;
          break;
        }
      }
    },

    // 获取填写项展示序号（标题类型不占用序号）
    getFieldDisplayIndex(index) {
      if (!this.allSignFields || !this.allSignFields.length) return 0;
      let count = 0;
      for (let i = 0; i <= index; i++) {
        if (this.allSignFields[i].type != 33) {
          count++;
        }
      }
      return count;
    },

    // 切换逻辑类型
    switchLogicType(type) {
      if (type === this.logicType) return;

      // 检查是否已有设置
      const hasExistingRules = this.currentFieldContent.some(
        (item) => item.logicRules && item.logicRules.length > 0,
      );

      if (hasExistingRules) {
        this.pendingSwitchType = type;
        this.switchConfirmPopupVisible = true;
      } else {
        this.logicType = type;
      }
    },

    // 确认切换（清空已有设置）
    confirmSwitch() {
      this.logicType = this.pendingSwitchType;
      // 清空所有选项的逻辑规则
      this.currentFieldContent.forEach((item) => {
        this.$set(item, "logicRules", []);
      });
      this.switchConfirmPopupVisible = false;
    },

    // 取消切换
    cancelSwitch() {
      this.pendingSwitchType = "";
      this.switchConfirmPopupVisible = false;
    },

    // 打开设置弹窗
    openSetPopup(index) {
      console.log(
        "openSetPopup called, index:",
        index,
        "logicType:",
        this.logicType,
      );
      this.editingOptionIndex = index;
      const option = this.currentFieldContent[index];
      console.log("option:", option);

      if (this.logicType === "SHOW") {
        // 初始化临时选中列表
        this.tempShowFieldIds = [];
        this.tempShowSubOptions = {};

        if (option.logicRules && option.logicRules.length > 0) {
          const showRule = option.logicRules.find((r) => r.ruleType === "SHOW");
          if (showRule && showRule.jumpToQuestionId) {
            const tempIds = [];
            String(showRule.jumpToQuestionId)
              .split(",")
              .forEach((id) => {
                const rawId = id.trim();
                let fieldPart = rawId;
                let optionsPart = null;

                if (rawId.includes(":")) {
                  [fieldPart, optionsPart] = rawId.split(":");
                }

                // 匹配逻辑：优先匹配显示的序号
                const f =
                  this.availableFields.find(
                    (af) => String(af.displayIndex) === fieldPart,
                  ) ||
                  this.availableFields.find(
                    (af) =>
                      String(af.id) === fieldPart ||
                      String(af.originalIndex) === fieldPart,
                  );

                if (f) {
                  const fId = String(f.fieldId);
                  tempIds.push(fId);

                  if (optionsPart) {
                    const indices = optionsPart
                      .split("|")
                      .map((n) => parseInt(n))
                      .filter((n) => !isNaN(n));
                    this.$set(this.tempShowSubOptions, fId, {
                      all: false,
                      selectedIndices: indices,
                    });
                  } else {
                    this.$set(this.tempShowSubOptions, fId, {
                      all: true,
                      selectedIndices: f.content
                        ? f.content.map((_, i) => i)
                        : [],
                    });
                  }
                }
              });
            this.tempShowFieldIds = tempIds;
          }
        }
        this.showPopupVisible = true;
      } else {
        // JUMP 模式
        this.selectedJumpTarget = null;
        if (option.logicRules && option.logicRules.length > 0) {
          const jumpRule = option.logicRules.find((r) => r.ruleType === "JUMP");
          if (jumpRule) {
            if (
              jumpRule.jumpToQuestionId === -1 ||
              jumpRule.jumpToQuestionId === "-1"
            ) {
              this.selectedJumpTarget = "end";
            } else {
              // 找到对应的 field
              const targetStr = String(jumpRule.jumpToQuestionId).trim();
              const targetField =
                this.availableFields.find(
                  (f) => String(f.displayIndex) === targetStr,
                ) ||
                this.availableFields.find(
                  (f) =>
                    String(f.id) === targetStr ||
                    String(f.originalIndex) === targetStr,
                );
              if (targetField) {
                this.selectedJumpTarget = targetField;
              }
            }
          }
        }
        this.jumpPopupVisible = true;
      }
    },

    // =================== SHOW 模式方法 ===================

    // 切换显示项选中状态
    toggleShowField(field) {
      const fieldId = String(field.fieldId);
      const idx = this.tempShowFieldIds.indexOf(fieldId);
      if (idx > -1) {
        this.tempShowFieldIds.splice(idx, 1);
        this.$delete(this.tempShowSubOptions, fieldId);
      } else {
        this.tempShowFieldIds.push(fieldId);
        // 勾选时默认全选子选项
        if (this.isChoiceField(field)) {
          this.$set(this.tempShowSubOptions, fieldId, {
            all: true,
            selectedIndices: field.content
              ? field.content.map((_, i) => i)
              : [],
          });
        } else {
          this.$set(this.tempShowSubOptions, fieldId, { all: true });
        }
      }
    },

    // 判断是否为选项类题目
    isChoiceField(field) {
      // 2: 单选，4: 多选
      return field.type == 2 || field.type == 4;
    },

    // 获取子选项设置文字
    getSubSettingText(field) {
      const fieldId = String(field.fieldId);
      const setting = this.tempShowSubOptions[fieldId];
      if (!this.isShowFieldSelected(field) || !setting) {
        return "选择子选项";
      }
      if (setting.all) {
        return "已全选";
      }
      return `已选择${setting.selectedIndices.length}项`;
    },

    // 打开子选项弹窗
    openSubPopup(field) {
      this.currentSubField = field;
      const fieldId = String(field.fieldId);
      const setting = this.tempShowSubOptions[fieldId];

      if (setting) {
        this.tempSubIndices = [...(setting.selectedIndices || [])];
      } else {
        // 如果之前没选中该题目，点击进入时自动选中它并全选
        this.tempShowFieldIds.push(fieldId);
        this.tempSubIndices = field.content
          ? field.content.map((_, i) => i)
          : [];
        this.$set(this.tempShowSubOptions, fieldId, {
          all: true,
          selectedIndices: [...this.tempSubIndices],
        });
      }
      this.subPopupVisible = true;
    },

    closeSubPopup() {
      this.subPopupVisible = false;
    },

    toggleSubOption(idx) {
      const pos = this.tempSubIndices.indexOf(idx);
      if (pos > -1) {
        this.tempSubIndices.splice(pos, 1);
      } else {
        this.tempSubIndices.push(idx);
      }
    },

    toggleAllSubOptions() {
      if (this.isAllSubSelected) {
        this.tempSubIndices = [];
      } else {
        this.tempSubIndices = this.currentSubField.content.map((_, i) => i);
      }
    },

    confirmSubSetting() {
      const fieldId = String(this.currentSubField.fieldId);
      const isAll =
        this.tempSubIndices.length === this.currentSubField.content.length;

      // 如果一个子选项都没选，则视为取消选中该题目
      if (this.tempSubIndices.length === 0) {
        const idx = this.tempShowFieldIds.indexOf(fieldId);
        if (idx > -1) this.tempShowFieldIds.splice(idx, 1);
        this.$delete(this.tempShowSubOptions, fieldId);
      } else {
        this.$set(this.tempShowSubOptions, fieldId, {
          all: isAll,
          selectedIndices: [...this.tempSubIndices],
        });
      }
      this.subPopupVisible = false;
    },

    // 判断显示项是否被选中
    isShowFieldSelected(field) {
      return this.tempShowFieldIds.includes(String(field.fieldId));
    },

    // 确认显示设置
    confirmShowSetting() {
      const option = this.currentFieldContent[this.editingOptionIndex];
      if (this.tempShowFieldIds.length > 0) {
        // 编码为 jumpToQuestionId 格式：ID1,ID2:opt1|opt2,ID3
        const encodedIds = this.tempShowFieldIds.map((fId) => {
          const setting = this.tempShowSubOptions[fId];
          if (
            setting &&
            !setting.all &&
            setting.selectedIndices &&
            setting.selectedIndices.length > 0
          ) {
            return `${fId}:${setting.selectedIndices.join("|")}`;
          }
          return fId;
        });

        this.$set(option, "logicRules", [
          {
            ruleType: "SHOW",
            jumpToQuestionId: encodedIds.join(","),
          },
        ]);
      } else {
        this.$set(option, "logicRules", []);
      }
      this.showPopupVisible = false;
    },

    closeShowPopup() {
      this.showPopupVisible = false;
    },

    // =================== JUMP 模式方法 ===================

    // 选择跳转目标
    selectJumpTarget(target) {
      this.selectedJumpTarget = target;
    },

    // 判断跳转目标是否被选中
    isJumpFieldSelected(field) {
      if (!this.selectedJumpTarget || this.selectedJumpTarget === "end")
        return false;
      return String(this.selectedJumpTarget.fieldId) === String(field.fieldId);
    },

    // 确认跳转设置
    confirmJumpSetting() {
      const option = this.currentFieldContent[this.editingOptionIndex];
      if (this.selectedJumpTarget) {
        let jumpId;
        if (this.selectedJumpTarget === "end") {
          jumpId = -1;
        } else {
          jumpId = this.selectedJumpTarget.fieldId;
        }
        this.$set(option, "logicRules", [
          {
            ruleType: "JUMP",
            jumpToQuestionId: jumpId,
          },
        ]);
      } else {
        this.$set(option, "logicRules", []);
      }
      this.jumpPopupVisible = false;
    },

    closeJumpPopup() {
      this.jumpPopupVisible = false;
    },

    // =================== 通用方法 ===================

    // 判断选项是否有逻辑规则
    hasOptionRule(item) {
      return item.logicRules && item.logicRules.length > 0;
    },

    // 获取选项的逻辑规则说明文字
    getOptionRuleText(item) {
      if (!item.logicRules || item.logicRules.length === 0) return "";
      const rule = item.logicRules[0];

      if (rule.ruleType === "SHOW") {
        const ids = String(rule.jumpToQuestionId).split(",");
        const segments = ids
          .map((id) => {
            const rawId = id.trim();
            const parts = rawId.split(":");
            const fieldPart = parts[0];
            const hasPartial = parts.length > 1;

            const field =
              this.availableFields.find(
                (f) => String(f.displayIndex) === fieldPart,
              ) ||
              this.availableFields.find(
                (f) =>
                  String(f.id) === fieldPart ||
                  String(f.originalIndex) === fieldPart,
              );
            if (field) {
              return `第${field.displayIndex}题${
                hasPartial ? "(部分选项)" : ""
              }`;
            }
            return null;
          })
          .filter((s) => s !== null);

        if (segments.length > 0) {
          return "显示" + segments.join("、");
        }
        return "";
      }

      if (rule.ruleType === "JUMP") {
        if (rule.jumpToQuestionId === -1 || rule.jumpToQuestionId === "-1") {
          return "跳转至结束";
        }
        const targetStr = String(rule.jumpToQuestionId).trim();
        const field =
          this.availableFields.find(
            (f) => String(f.displayIndex) === targetStr,
          ) ||
          this.availableFields.find(
            (f) =>
              String(f.id) === targetStr ||
              String(f.originalIndex) === targetStr,
          );
        if (field) {
          return "跳转至第" + field.displayIndex + "题";
        }
        return "";
      }

      return "";
    },

    // 保存逻辑设置
    saveLogic() {
      // 更新原始数据的 content
      const updatedFieldData = JSON.parse(
        JSON.stringify(this.currentFieldData),
      );
      updatedFieldData.content = JSON.parse(
        JSON.stringify(this.currentFieldContent),
      );

      // 触发 save 事件，将数据传递给父组件
      this.$emit("save", {
        fieldData: updatedFieldData,
        fieldIndex: this.currentFieldIndex,
        listIndex: this.$props.listIndex,
      });

      this.$message.success("保存成功");
      this.handleClose();
    },

    // 关闭弹层
    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.set-logic-dialog {
  :deep(.el-dialog__body) {
    padding: 20px;
  }
}

.set-logic-content {
  max-height: 500px;
  overflow-y: auto;
  margin-top: -24px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 15px 0 10px;
}

/* 逻辑类型选择 */
.logic-type-box {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0 12px;
  margin-bottom: 15px;
}

.logic-type-item {
  display: flex;
  align-items: flex-start;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f9f9f9;
  }
}

.logic-type-active {
  .logic-type-name {
    color: #1877ff;
  }
}

.logic-check-box {
  width: 22px;
  height: 22px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.check-icon {
  width: 20px;
  height: 20px;
}

.check-empty {
  width: 18px;
  height: 18px;
  border: 2px solid #ddd;
  border-radius: 3px;
}

.logic-type-info {
  flex: 1;
}

.logic-type-name {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.active-text {
  color: #1877ff;
}

.logic-type-desc {
  font-size: 12px;
  color: #999;
}

/* 选项列表 */
.option-list {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0 12px;
}

.option-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f9f9f9;
  }
}

.option-left {
  display: flex;
  align-items: flex-start;
  flex: 1;
}

.option-number {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #666;
  margin-right: 8px;
  flex-shrink: 0;
}

.option-info {
  flex: 1;
}

.option-name {
  font-size: 14px;
  color: #333;
}

.option-rule-text {
  font-size: 12px;
  color: #1877ff;
  margin-top: 4px;
}

.option-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.option-status {
  font-size: 13px;
  color: #999;
  margin-right: 4px;
}

.option-status.has-set {
  color: #333;
}

/* 内层弹窗样式 */
.inner-popup-dialog {
  :deep(.el-dialog__body) {
    padding: 15px;
  }
}

.popup-scroll {
  max-height: 400px;
  overflow-y: auto;
}

.popup-item-wrap {
  border-bottom: 1px solid #f5f5f5;

  &:last-child {
    border-bottom: none;
  }
}

.popup-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  cursor: pointer;

  &:hover {
    background-color: #f9f9f9;
  }
}

.popup-check-box {
  width: 22px;
  height: 22px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.popup-item-text {
  font-size: 14px;
  color: #333;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
}

.option-badge {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #d0d0d0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #91908f;
  flex-shrink: 0;
}

.sub-setting-entry {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: 10px;
  margin-right: 30px;
}

.sub-setting-text {
  font-size: 12px;
  color: #999;
  margin-right: 4px;

  &.selected-text {
    color: #1877ff;
  }
}

.sub-field-info {
  padding: 10px 15px;
  background-color: #f9f9f9;
  font-size: 14px;
  color: #666;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}

.sub-all-check {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}

.popup-footer-btns {
  display: flex;
  gap: 10px;
  align-items: center;
}

.norecord-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;

  .norecord-img {
    width: 87px;
    height: 96px;
  }

  .norecord-text {
    font-size: 14px;
    color: #a7adc6;
    text-align: center;
    margin-top: 10px;
  }
}

/* 确认弹窗 */
.confirm-dialog {
  :deep(.el-dialog__body) {
    padding: 15px;
  }
}

.confirm-body {
  padding: 20px 15px;
  font-size: 14px;
  color: #666;
  text-align: center;
}

.confirm-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
}
</style>
